import {Component, OnInit} from '@angular/core';
import {AttendanceService} from '@services/attendance/attendance.service';

@Component({
    selector: 'app-check-ins-teacher',
    templateUrl: './check-ins-teacher.component.html',
    styleUrls: ['./check-ins-teacher.component.scss']
})
export class CheckInsTeacherComponent implements OnInit {
  static modalRef;
  static items;
  static user;
  items;

  constructor(
    private attendanceService: AttendanceService
  ) { }

  ngOnInit() {
    this.items = CheckInsTeacherComponent.items;
    console.log(this.items);
  }

  getFundamentals(schoolID) {
  }

  close() {
      CheckInsTeacherComponent.modalRef.close();
  }
}
